import { ReactNode } from 'react';

import { Box, BoxProps, Container, ContainerProps } from '@mui/material';
import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()(theme => ({
    container: {
        paddingBottom: theme.spacing(1),
        paddingTop: theme.spacing(1),
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
    },
}));

type PageContainerProps = Omit<BoxProps, 'maxWidth' | 'maxHeight'> & {
    children: ReactNode;
    dataTestId?: string;
    maxWidth?: ContainerProps['maxWidth'] | false;
    maxHeight?: string;
};

export function PageContainer({
    children,
    dataTestId,
    maxWidth,
    maxHeight = 'none',
    ...otherProps
}: PageContainerProps) {
    const { classes } = useStyles();
    return (
        <Box
            data-testid={dataTestId}
            {...otherProps}
            sx={[
                {
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'auto',
                },
                ...(Array.isArray(otherProps.sx) ? otherProps.sx : [otherProps.sx]),
            ]}
        >
            <Container className={classes.container} maxWidth={maxWidth ?? undefined} style={{ maxHeight }}>
                {children}
            </Container>
        </Box>
    );
}
